// Module
var code = `<dialog class="dialog-edge-selection">
    <h3>calls</h3>
    <form method="dialog">
        <ul class="edge-selection"></ul>
        <input type=submit value="close">
    </form>
</dialog>`;
// Exports
export default code;